import './helpers/compatibility.js';
import ParallaxHero from './components/ParallaxHero/ParallaxHero.js';
import ResponsiveVideo from './components/ResponsiveVideo/ResponsiveVideo.html';
import PlatformInteractive from './components/PlatformInteractive/PlatformInteractive.js';

/*
 * Parallax Hero
 */
const hero = new ParallaxHero({
    wrapper: document.querySelector('.c-page-hero'),
    body: document.querySelector('.c-page-hero__body'),
    header: document.querySelector('.c-page-header'),
});

/*
 * Hero Video
 */
const variants = [
    {
        id: 'portrait_large',
        width: 1080,
        height: 1080,
        sources: [{
            type: 'video/webm',
            url: '/assets/images/platform/hero/video_portrait_large.webm',
        }, {
            type: 'video/mp4',
            url: '/assets/images/platform/hero/video_portrait_large.mp4'
        }]
    }, {
        id: 'portrait_medium',
        width: 720,
        height: 720,
        sources: [{
            type: 'video/webm',
            url: '/assets/images/platform/hero/video_portrait_medium.webm',
        }, {
            type: 'video/mp4',
            url: '/assets/images/platform/hero/video_portrait_medium.mp4'
        }]
    }, {
        id: 'landscape_large',
        width: 1920,
        height: 1080,
        sources: [{
            type: 'video/webm',
            url: '/assets/images/platform/hero/video_large.webm',
        }, {
            type: 'video/mp4',
            url: '/assets/images/platform/hero/video_large.mp4'
        }]
    }, {
        id: 'landscape_medium',
        width: 1280,
        height: 720,
        sources: [{
            type: 'video/webm',
            url: '/assets/images/platform/hero/video_medium.webm',
        }, {
            type: 'video/mp4',
            url: '/assets/images/platform/hero/video_medium.mp4'
        }]
    }
];

const heroVideo = new ResponsiveVideo({
    target: document.querySelector('.c-page-hero__background'),
    data: {
        width: '100%',
        height: '100%',
        poster: '/assets/images/platform/hero/fallback/fallback_medium.jpg',
        variants,
    }
});

new PlatformInteractive(document.querySelector('.c-platform-interactive'));
